"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainTokenMintKeys = void 0;
const spl_token_1 = require("@solana/spl-token");
exports.mainTokenMintKeys = {
    /** Wrapped SOL's mint address */
    NATIVE_MINT: spl_token_1.NATIVE_MINT,
    USDC: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    BTC_SOLLET: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    ETH_SOLLET: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk"
};
//# sourceMappingURL=tokenMintKeys.js.map